import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import authService from '../services/authService';

function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="page">
        <main className="main">
          <div className="card" style={{textAlign: 'center'}}>
            <p>Loading...</p>
          </div>
        </main>
      </div>
    );
  }

  // Check both state and localStorage for authentication
  // This handles the case where state hasn't updated yet after login
  const hasToken = authService.getToken();
  if (!isAuthenticated && !hasToken) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

export default ProtectedRoute;

